<template functional>
  <div style="align-content: center">
    <strong><translate-text keyTranslate="common_words.method" />:</strong>
    {{ props.row.receiving_method }}
    <br />
    <strong><translate-text keyTranslate="common_words.week" />:</strong>
    {{ props.row.reception_week }}
    <br />
    <strong><translate-text keyTranslate="common_words.date" />:</strong>
    {{ props.row.reception_date }}
    <br />
  </div>
</template>
<script>
export default {
  name: 'ReceptionDataFormatter',
};
</script>
